import React from 'react';
import PropTypes from 'prop-types';
import { LINEUPS_MOCK } from '../../mock/matchDetailLineupsData';
import Assets from '../../../../../requests/apa/Asset';
import './_MatchDetailLineupsTopBar.scss';

const DEFAULT_HOME_TEAM = {
  name: LINEUPS_MOCK.homeTeam.name,
  flagUrl: LINEUPS_MOCK.homeTeam.flagUrl,
  formation: LINEUPS_MOCK.homeTeam.formation
};

const DEFAULT_AWAY_TEAM = {
  name: LINEUPS_MOCK.awayTeam.name,
  flagUrl: LINEUPS_MOCK.awayTeam.flagUrl,
  formation: LINEUPS_MOCK.awayTeam.formation
};

const getTeamData = (lineupsTeam, matchTeam, fallback) => ({
  name: (lineupsTeam && lineupsTeam.name) || (matchTeam && matchTeam.name) || fallback.name,
  flagUrl: (lineupsTeam && lineupsTeam.flagUrl) || (matchTeam && (matchTeam.flagUrl || matchTeam.badgeUrl)) || fallback.flagUrl,
  formation: (lineupsTeam && lineupsTeam.formation) || fallback.formation
});

const MatchDetailLineupsTopBar = ({ lineups, homeTeam, awayTeam }) => {
  const safeHomeTeam = getTeamData(lineups && lineups.homeTeam, homeTeam, DEFAULT_HOME_TEAM);
  const safeAwayTeam = getTeamData(lineups && lineups.awayTeam, awayTeam, DEFAULT_AWAY_TEAM);

  return (
    <div className="match-detail-lineups-top-bar" aria-hidden="true">
      <div className="match-detail-lineups-top-bar__col match-detail-lineups-top-bar__col--home">
        <span className="match-detail-lineups-top-bar__team-row">
          {safeHomeTeam.flagUrl ? (
            <img
              src={safeHomeTeam.flagUrl}
              alt=""
              className="match-detail-lineups-top-bar__flag"
            />
          ) : (
            <img
              src={Assets.get('eventodeportivo_placeholder_imagen_escudo_1')}
              alt=""
              className="match-detail-lineups-top-bar__flag"
            />
          )}
          <span className="match-detail-lineups-top-bar__team-name">{safeHomeTeam.name}</span>
        </span>
        <span className="match-detail-lineups-top-bar__formation">{safeHomeTeam.formation}</span>
      </div>

      <div className="match-detail-lineups-top-bar__col match-detail-lineups-top-bar__col--away">
        <span className="match-detail-lineups-top-bar__team-row">
          <span className="match-detail-lineups-top-bar__team-name">{safeAwayTeam.name}</span>
          {safeAwayTeam.flagUrl ? (
            <img
              src={safeAwayTeam.flagUrl}
              alt=""
              className="match-detail-lineups-top-bar__flag"
            />
          ) : (
            <img
              src={'eventodeportivo_placeholder_imagen_escudo_1'}
              alt=""
              className="match-detail-lineups-top-bar__flag"
            />
          )}
        </span>
        <span className="match-detail-lineups-top-bar__formation">{safeAwayTeam.formation}</span>
      </div>
    </div>
  );
};

MatchDetailLineupsTopBar.propTypes = {
  lineups: PropTypes.shape({
    homeTeam: PropTypes.shape({
      name: PropTypes.string,
      flagUrl: PropTypes.string,
      formation: PropTypes.string
    }),
    awayTeam: PropTypes.shape({
      name: PropTypes.string,
      flagUrl: PropTypes.string,
      formation: PropTypes.string
    })
  }),
  homeTeam: PropTypes.shape({
    name: PropTypes.string,
    flagUrl: PropTypes.string,
    badgeUrl: PropTypes.string
  }),
  awayTeam: PropTypes.shape({
    name: PropTypes.string,
    flagUrl: PropTypes.string,
    badgeUrl: PropTypes.string
  })
};

MatchDetailLineupsTopBar.defaultProps = {
  lineups: null,
  homeTeam: null,
  awayTeam: null
};

export default MatchDetailLineupsTopBar;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailLineupsTopBar/MatchDetailLineupsTopBar.jsx